/**
 * @tabler/icons-vue v2.20.0 - MIT
 */

import { h } from 'vue';
import defaultAttributes from './defaultAttributes.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createVueComponent = (iconName, iconNamePascal, iconNode) => (_a, { attrs, slots }) => {
  var _b = _a, { size, color, stroke } = _b, props = __objRest(_b, ["size", "color", "stroke"]);
  return h(
    "svg",
    __spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, defaultAttributes), {
      width: size || defaultAttributes.width,
      height: size || defaultAttributes.height,
      stroke: color || defaultAttributes.stroke,
      strokeWidth: stroke || defaultAttributes["stroke-width"]
    }), attrs), {
      class: ["tabler-icon", `tabler-icon-${iconName}`, (attrs == null ? void 0 : attrs.class) || ""]
    }), props),
    [
      ...iconNode.map((child) => h(...child)),
      ...slots.default ? [slots.default()] : []
    ]
  );
};

export { createVueComponent as default };
//# sourceMappingURL=createVueComponent.js.map
